module.exports = __webpack_public_path__ + "media/components/assets/img/logo/mono/gray/visa-e0eb15774c25474a283bb9b0b6d27b48.svg";